import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { RepeatTypeComponent } from 'app/core/formly/custom-templates/repeat-type.form-template';
import { SelectCostObjectFormTemplateComponent } from 'app/core/formly/custom-templates/select-cost-object-form-template/select-cost-object-form-template.component';
import { SelectCostCenterComponent } from 'app/core/formly/custom-templates/select-cost-object/select-cost-object.component';
import { SelectDataElementsFormTemplateComponent } from 'app/core/formly/custom-templates/select-data-elements-form-template/select-data-elements-form-template.component';
import { SelectDictionaryFieldsFormTemplateComponent } from 'app/core/formly/custom-templates/select-dictionary-fields-form-template/select-dictionary-fields-form-template.component';
import { SelectDictionaryTableFormTemplateComponent } from 'app/core/formly/custom-templates/select-dictionary-table-form-template/select-dictionary-table-form-template.component';
import { SelectDmObjectFormTemplateComponent } from 'app/core/formly/custom-templates/select-dm-object-form-template/select-dm-object-form-template.component';
import { SelectJiraAccountsFormTemplateComponent } from 'app/core/formly/custom-templates/select-jira-accounts-form-template/select-jira-accounts-form-template.component';
import { SelectMdObjectFormTemplateComponent } from 'app/core/formly/custom-templates/select-md-object-form-template/select-md-object-form-template.component';
import { SelectServiceFormTemplateComponent } from 'app/core/formly/custom-templates/select-service-form-template/select-service-form-template.component';
import { SelectTableFormTemplateComponent } from 'app/core/formly/custom-templates/select-table-form-template/select-table-form-template.component';
import { SelectTransactionTableForSAPComponent } from 'app/core/formly/custom-templates/select-transaction-table-for-sap/select-transaction-table-for-sap.component';
import { SelectTransactionComponent } from 'app/core/formly/custom-templates/select-transaction/select-transaction.component';
import { FormlyStatusCircleComponent } from 'app/core/formly/custom-templates/status-circle.type';
import { MaterialLabelWrapperComponent } from 'app/core/formly/custom-wrappers/material-label-wrapper.component';
import { noCapitalLetters } from 'app/modules/data-module/dictionary/data-fields/data-fields.service';
import { SelectRicefwComponent } from './custom-templates/select-ricefw/select-ricefw.component';
import { FormlyArrayTypeComponent } from './form-types/formly-array-type/formly-array-type.component';
import { FormlyCopytoClipboardButtonComponent } from './form-types/formly-button/formly-copy-button.component';
import { FormlyLinkButtonComponent } from './form-types/formly-link-button/formly-link-button.component';
import { FormlyObjectTypeComponent } from './form-types/formly-object-type/formly-object-type.component';
import { FormlyCustomType } from './formly-custom-type';
import { SelectRicefwFormTemplateComponent } from 'app/modules/ricefw/select-ricefw-dialog/select-ricefw-form-template/select-ricefw-form-template.component';

export const provideFormly = (): Array<Provider | EnvironmentProviders> => {
    return [
        importProvidersFrom(
            FormlyModule.forRoot({
                validationMessages: [
                    { name: 'required', message: 'This field is required' },
                    { name: 'noCapitalLetters', message: 'No special characters' },
                ],
                types: [
                    {
                        name: FormlyCustomType.MdObjectDialog, // 'md-object-dialog',
                        component: SelectMdObjectFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.DmObjectDialog, // 'dm-object-dialog',
                        component: SelectDmObjectFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.TableDialog, // 'table-dialog',
                        component: SelectTableFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.DataElementsDialog, // 'data-elements-dialog',
                        component: SelectDataElementsFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.Object, // 'object',
                        component: FormlyObjectTypeComponent,
                    },
                    {
                        name: FormlyCustomType.Array, // 'array',
                        component: FormlyArrayTypeComponent,
                    },
                    {
                        name: FormlyCustomType.SelectTransaction, // 'select-transaction',
                        component: SelectTransactionComponent,
                    },
                    {
                        name: FormlyCustomType.SelectTransactionTable, // 'select-transaction-table',
                        component: SelectTransactionTableForSAPComponent,
                    },
                    {
                        name: FormlyCustomType.SelectCostCenter, // 'select-cost-center',
                        component: SelectCostCenterComponent,
                    },
                    {
                        name: FormlyCustomType.SelectJiraAccounts, // 'select-jira-accounts',
                        component: SelectJiraAccountsFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.SelectFileLinks, // 'select-file-links',
                        component: FormlyCopytoClipboardButtonComponent,
                    },
                    {
                        name: FormlyCustomType.SelectCostObject, // 'select-cost-object',
                        component: SelectCostObjectFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.SelectService, // 'select-service',
                        component: SelectServiceFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.CopyButton, // 'copy-button',
                        component: FormlyCopytoClipboardButtonComponent,
                    },
                    {
                        name: FormlyCustomType.LinkButton, // 'link-button',
                        component: FormlyLinkButtonComponent,
                    },
                    {
                        name: FormlyCustomType.SelectDictionaryTable, // 'select-dictionary-table',
                        component: SelectDictionaryTableFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.SelectDictionaryFields, // 'select-dictionary-fields',
                        component: SelectDictionaryFieldsFormTemplateComponent,
                    },
                    {
                        name: FormlyCustomType.Repeat, // 'repeat',
                        component: RepeatTypeComponent,
                    },
                    {
                        name: FormlyCustomType.StatusCircle, // 'status-circle',
                        component: FormlyStatusCircleComponent,
                    },
                    {
                        name: FormlyCustomType.Ricefw, // 'ricefw instance selector',
                        component: SelectRicefwComponent,
                    },
                    {
                        name: FormlyCustomType.RicefwFormTemplate, // 'ricefw form template',
                        component: SelectRicefwFormTemplateComponent,
                    },
                ],
                wrappers: [
                    {
                        name: 'material-label-wrapper',
                        component: MaterialLabelWrapperComponent,
                    },
                ],
                validators: [{ name: 'noCapitalLetters', validation: noCapitalLetters }],
            })
        ),
    ];
};
